// ----------------------------------------------------------------------

/**
 * A student's name for display, falling back to "Student <ASN>" when there is
 * no name, so a bare nine-digit number never stands in for a name (a page
 * title reading "835712627"). With neither, `fallback`.
 *
 * @param {string} [name]
 * @param {string|number} [asn]
 * @param {string} [fallback]
 */
export function studentDisplayName(name, asn, fallback = 'Student') {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (trimmed) return trimmed;
  const id = asn != null ? String(asn).trim() : '';
  return id ? `Student ${id}` : fallback;
}
